import axios from "axios";
import { message } from 'antd'
import {baseUrl} from './baseUrl'
// import qs from "qs";
//接口地址前缀
const host = baseUrl();

// 创建axios实例
const instance = axios.create({
    // baseURL  公共接口路径
    baseURL: host,
    // timeout 超时时间
    timeout: 10000
});
// 请求拦截器
instance.interceptors.request.use(
    config => {
        message.loading({ content: 'Loading...', key: 'loading-request', duration: 0 });
        let userToken = localStorage.getItem('ai-chat-auth-id');
        if (config.url !== "user/user") {
            config.headers = {
                "auth-id": userToken
            }
        }
        if (config.method.toLowerCase() !== 'get') {
            config.headers['Content-Type'] = 'application/json;charset=UTF-8'
            // config.data = qs.stringify(config.data)
        } else {
            config.params = config.data
            config.data = null
        }
        if(config.url.includes('update_avatar')){
            config.headers['Content-Type'] = 'multipart/form-data'
        }
        if(config.url.includes('hyperChat/upload/image')){
            config.headers['Content-Type'] = 'multipart/form-data'
        }
        return config
    },
    error => {
        message.error('数据异常！请联系管理员！');
        console.log(error) // for debug
        return Promise.reject(error)
    }
)

// 响应拦截器

instance.interceptors.response.use(

    response => {
        message.destroy('loading-request')
        const res = response?.data
        if (res.code * 1 !== 200) {
            if(res?.detail?.includes('等待支付')) return res
            if(!res?.detail) return res
            message.error(res.detail);
        }
        return res
    },
    error => {
        const {response} = error
        message.destroy('loading-request')
        if(response?.data?.detail){
            message.error(response?.data?.detail || '请检查数据后再执行操作！');
        }else{
            message.error('操作失败')
        }
        console.log('err' + error) // for debug
        return response
        // return Promise.reject(error)
    }
)


export default instance
